import { gql } from "lib/apolloClient";
import { studentReportFragments } from "./ParentProgressReportFragments";
import { progressReportRemarkFragment } from "ProgressReportCommon/modules/ProgressReportFragments";
import { staffFragment } from "modules/CommonFragments";

export const getStudentProgressReportFeedQuery = gql`
  query getStudentProgressReportFeed(
    $id: ID!
    $filters: PublishedProgressReportsFilter
  ) {
    node(id: $id, type: STUDENT) {
      id
      ... on Student {
        id
        publishedProgressReports(filters: $filters) {
          ...studentReportItem
        }
      }
    }
  }
  ${studentReportFragments.reportFeed}
`;

export const getStudentProgressReportReflectionsQuery = gql`
  query StudentProgressReportReflections(
    $id: ID!
    $filters: StudentProgressReportReflectionFilter
  ) {
    node(id: $id, type: STUDENT) {
      id
      ... on Student {
        id
        studentProgressReportReflections(filters: $filters) {
          studentProgressReportId
          reflectionDeadline
          progressReportName
          isReflectionEditable
          reflectionFeedback {
            id
            label
            isResolved
            createdBy {
              ...staffItem
            }
          }
          studentProgressReport {
            id
            studentReflectionStatus
          }
          academicTerms {
            id
            label
          }
        }
      }
    }
  }
  ${staffFragment.basicStaffDetails}
`;

export const getStudentReflectionReportRemarkQuery = gql`
  query getStudentReflectionReportRemark(
    $id: ID!
    $remarkFilters: StudentReportRemarkFilter
  ) {
    node(id: $id, type: STUDENT_PROGRESS_REPORT) {
      id
      ... on StudentProgressReport {
        id
        status
        studentReflectionTemplate
        remarks(filters: $remarkFilters) {
          ...progressReportRemarkItem
        }
      }
    }
  }
  ${progressReportRemarkFragment.progressReportRemark}
`;
